import { ISearchPaginationData } from './api.model'
import { ICompanyDto } from './company.model'

export interface IForecastDto {
  id: number
  capCategory: string
  epsForecastProximilar: number
  salesForecastProximilar: number
  epsSurpriseForecast: number
  salesSurpriseForecast: number
  epsSurpriseRating: number
  epsConsensus: number
  revConsensus: number
  salesSurpriseRating: number
  totalSurpriseRating: number
  postReleaseOvernightMove: number
  postRelease1weekMove: number
  bidAskPerUsd10k: number
  bidAskSpreadDollars: number
  forwardLookingBeta: number
  qrtrEndDate: string // TODO: Date
  announceDate: string // TODO: Date
  announceDays: number
  announceTime: string
  epsActual: number
  salesActual: number
  epsSurpriseActual: number
  salesSurpriseActual: number
  overnightMoveActual: number
  asofDate: string // TODO: Date
  isEarningRelease: boolean
  isExistReportSummary: boolean
  summary: string

  isFavorite: boolean
  company: ICompanyDto
  version: string
}

export interface IUserForecastDto {
  folderId: number
  isFavorite: boolean
}

export interface IForecastSearchPreviewDto {
  isExistReportSummary: boolean
  companyId: number
  ticker: string
  name: string
}

export interface ISearchForecastDataDto extends ISearchPaginationData {
  selectedTicker: string
  search: string
  filterValues: { [key: string]: any }
}

export interface IEdgarSummaryAiDto {
  id: number
  ticker: string
  summary: string
  message: string
  updatedBy: number
  status: EBatchStatus
  companyId: number
  batchId: string
  inputFileId: string
  outputFileId: string
  createdType: EBatchCreatedType

  createdAt: string // TODO: Date
  lastSucceedAt: string // TODO: Date
  updatedAt: string // TODO: Date
  startBatchAt: string // TODO: Date
  finishBatchAt: string // TODO: Date
}

export interface IEdgarStatisticAiDto {
  id: number
  ticker: string
  companyId: number
  createdAt: string // TODO: Date
  lastSucceedAt: string // TODO: Date
  updatedAt: string // TODO: Date
  status: EBatchStatus
  message: string
}

export interface IEdgarQueueStatisticAiDto {
  withoutReportByAnnounce: number
  withoutFreshReport: number
  withoutReport: number
}

export enum EDashRoute {
  ALL_FORECASTS = 'All forecasts',
  FAVORITES = 'Favorites',
  FOLDER = 'Folder',
}

export enum EBatchStatus {
  S3_NOT_FOUND = 'S3_NOT_FOUND',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  FAILED = 'FAILED',
}

export enum EBatchCreatedType {
  MANUAL = 'MANUAL',
  SCHEDULE = 'SCHEDULE',
}
